import { ValidationError } from "sequelize"
import {
    CcRequirementPriority,
    CcRequirementPriorityCreate,
    CcRequirementPrioritySave,
} from "server/models"
import { GET, POST, DELETE, sort, validate } from "client/store/utils"
import { LangType } from "client/store"
import { ASC } from "const"
import {
    CcRequirementPriorityList,
    CcRequirementPriorityValidation,
} from "./types"


export const GetDefaultPriority = (
    priorityList: CcRequirementPriorityList,
    priorityIds: readonly number[],
) => {
    let defaultPriority: CcRequirementPriority = null
    priorityIds.forEach((id) => {
        const priority = priorityList[id]
        if (priority.default) defaultPriority = priority
    })

    if (!defaultPriority && priorityIds.length) defaultPriority = priorityList[priorityIds[0]]
    return defaultPriority
}

export const LoadCcRequirementPriorities = (
    accountId: number,
    projectId: number,
) => (
    GET(`/ccRequirementPriority/accountId/${accountId}/projectId/${projectId}`)
    .then((priorities: CcRequirementPriority[]) => {
        const priorityList: CcRequirementPriorityList = {}
        priorities.forEach((priority) => {
            priorityList[priority.id] = priority
        })

        const prioritiesSorted = priorities.sort((a, b) => sort(a, b, "order", ASC))
        const priorityIds: number[] = []
        prioritiesSorted.forEach((priority) => {
            priorityIds.push(priority.id)
        })

        return { priorityList, priorityIds }
    })
)

export const LoadCcRequirementPriorityById = (
    priorityId: number,
    accountId: number,
    projectId: number,
) => (
    GET(`/ccRequirementPriority/id/${priorityId}/accountId/${accountId}/projectId/${projectId}`)
    .then((priority: CcRequirementPriority) => priority)
)

export const SaveCcRequirementPriority = (
    id: number,
    priority: CcRequirementPriorityCreate,
    lang: LangType,
) => {
    const data: CcRequirementPrioritySave = {
        id,
        priority,
    }
    return POST(
        "/ccRequirementPriority/save",
        JSON.stringify(data),
    ).then((res) => {
        const newPriority = res as CcRequirementPriority
        const error = res as ValidationError
        return {
            newPriorityId: newPriority.id || null,
            newPriorityOrder: newPriority.order || null,
            validation: <CcRequirementPriorityValidation>validate(error, lang),
        }
    })
}

export const DragnDropCcRequirementPriority = (
    priorityIds: readonly number[],
    priorityList: CcRequirementPriorityList,
) => {
    const data: CcRequirementPriority[] = []
    priorityIds.forEach((id, index) => {
        data.push({
            ...priorityList[id],
            order: index,
        })
    })

    return POST(
        "/ccRequirementPriority/updateMany",
        JSON.stringify(data),
    ).then((success: boolean) => success)
}

export const DeleteCcRequirementPriority = (priorityId: number) => (
    DELETE(`/ccRequirementPriority/delete/${priorityId}`)
    .then((removedRows: number) => removedRows)
)

export const CopyDefaultCcRequirementPriorities = (
    accountId: number,
    projectId: number,
    defaultPrioritiesAssigned: boolean,
) => (
    GET(`/ccRequirementPriority/copyDefault/accountId/${accountId}/projectId/${projectId}/${defaultPrioritiesAssigned}`)
    .then((success: boolean) => success)
)
